<template>
  <v-card :class="cardClass" elevation="0" :style="cardStyle" v-bind="cardAttrs">
    <slot />
  </v-card>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

const props = withDefaults(
  defineProps<{
    unstyled?: boolean;
  }>(),
  {
    unstyled: false,
  },
);

defineOptions({
  inheritAttrs: false,
});

const attrs = useAttrs();

const cardClass = computed(() => [
  props.unstyled ? null : "app__card",
  attrs.class as any,
]);
const cardStyle = computed(() => attrs.style as any);

const cardAttrs = computed(() => {
  const { class: _class, style: _style, ...rest } = attrs;
  return rest;
});
</script>

<style scoped>
.app__card {
  padding: 12px;
  border-radius: 18px;
  background: #ffffff !important;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.app__card:focus,
.app__card:focus-visible,
.app__card:hover,
.app__card:active {
  box-shadow: none !important;
  transform: none;
  background: #ffffff !important;
}
</style>